import { maybeLoadAddOnsExtension } from "./addOns";
import { getSlotNode } from "./helpers";

/**
 * Dynamically attach content to slots from <template>'s
 *
 * Recharge uses client-side nav, so this is necessary to get
 * web component callbacks to run when slots are mounted/unmounted
 */
export async function loadSlotExtensions({ name, pathname }) {
  const slot = getSlotNode(name);
  if (!slot) return;

  const path = pathname.split("/")[1];
  const template = slot.querySelector(`template[data-path="${path}"]`);
  if (!template) return;

  // kind of a weird case, so handle differently
  if (path === "subscriptions") {
    await maybeLoadAddOnsExtension({ slot, template, pathname });
  } else {
    slot.setAttribute("hidden", "");

    const clone = template.content.cloneNode(true);

    slot.appendChild(clone);

    slot.removeAttribute("hidden");
  }
}

// remove any non-<template> content that was attached when slot mounted
export function unloadSlotExtensions({ name, pathname }) {
  const slot = getSlotNode(name);
  if (!slot) return;

  const path = pathname.split("/")[1];
  const slotContentForPath = slot.querySelector(
    `:not(template)[data-path="${path}"]`,
  );

  if (slotContentForPath) {
    slot.removeChild(slotContentForPath);
  }
}
